export default "__VITE_ASSET__DinX$wm6__"